import type { ReactNode } from 'react';
import { Navigate, NavLink } from 'react-router-dom';
import { useAuth } from '../../features/auth/AuthContext';
import { AppLayout } from '../../components/AppLayout';

/** Guard + layout del pannello Super Admin (lineeguida §68). */
export function AdminLayout({ title, children }: { title: string; children: ReactNode }) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <main className="grid min-h-screen place-items-center">
        <p role="status">Caricamento in corso…</p>
      </main>
    );
  }
  if (!user || user.globalRole !== 'SUPER_ADMIN') {
    return <Navigate to="/dashboard" replace />;
  }

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `rounded-lg px-3 py-2 font-medium no-underline min-h-11 inline-flex items-center ${
      isActive
        ? 'bg-panda-100 text-panda-900 dark:bg-panda-900 dark:text-panda-100'
        : 'text-ink-700 hover:bg-ink-100 dark:text-ink-200 dark:hover:bg-ink-800'
    }`;

  return (
    <AppLayout title={title}>
      <nav
        aria-label="Sezioni amministrazione piattaforma"
        className="mt-4 flex flex-wrap gap-1 border-b border-ink-200 pb-3 dark:border-ink-800"
      >
        <NavLink to="/admin" end className={linkClass}>
          Panoramica
        </NavLink>
        <NavLink to="/admin/utenti" className={linkClass}>
          Utenti
        </NavLink>
        <NavLink to="/admin/leghe" className={linkClass}>
          Leghe
        </NavLink>
        <NavLink to="/admin/dati" className={linkClass}>
          Dati calcio
        </NavLink>
        <NavLink to="/admin/audit" className={linkClass}>
          Audit log
        </NavLink>
      </nav>
      {children}
    </AppLayout>
  );
}
